'use client'
import { getFont } from '@/lib/fonts'

export function FontLoader({ fontFamily }: { fontFamily: string }) {
    if (!fontFamily) return null;

    const font = getFont(fontFamily);

    if (!font) return null;

    return (
        <>
            <style jsx global>{`
                :root {
                    /* Override Tailwind Variables */
                    --font-jakarta: ${font.style.fontFamily};
                    --font-ibm-arabic: ${font.style.fontFamily};
                    --font-sans: ${font.style.fontFamily};
                    
                    /* Utility Variables */
                    --font-body: ${font.style.fontFamily};
                    --font-heading: ${font.style.fontFamily};
                }
                
                body {
                    font-family: ${font.style.fontFamily} !important;
                }
                
                /* Aggressive Reset for Headings */
                h1, h2, h3, h4, h5, h6, p, span, div, a, button, input, textarea, select {
                    font-family: ${font.style.fontFamily} !important;
                }
            `}</style>
        </>
    )
}
